import React, { useEffect, useState } from "react";

type Variable = {
  key: string;
  name: string;
};

type Device = {
  type: string;
  leitura: { [key: string]: any }; // Dados da leitura
  variaveis: Variable[]; // Variáveis do dispositivo
  rulerVariables: Variable[]; // Variáveis do dispositivo
  eventos: { [key: string]: any };
  atraso: number;
};

type DeviceViewerProps = {
  device: Device;
  onCloseModal: () => void;
  CommandDj: () => void;
};

const DeviceViewer: React.FC<DeviceViewerProps> = ({
  device,
  onCloseModal,
  CommandDj,
}) => {
  const [deviceVariables, setDeviceVariables] = useState<Variable[]>([]);

  useEffect(() => {
    let variables = device.variaveis?.length
      ? device.variaveis
      : device.rulerVariables;

    if (variables?.length === 0 && device.leitura?.variaveis) {
      const keys = device.leitura.variaveis.map(
        (variable: any) => Object.keys(variable)[0]
      );
      variables = keys.map((key: any) => ({
        key,
        name: key,
      }));
    }

    if (
      variables?.length === 0 &&
      !device.leitura?.variaveis &&
      device?.leitura
    ) {
      variables = Object.keys(device.leitura).map((key: any) => ({
        key,
        name: key,
      }));
    }
    if (device.leitura) {
      variables.sort((a, b) => {
        const aValue = device.leitura[a.key];
        const bValue = device.leitura[b.key];
        if (bValue == "-") return -1;
        if (aValue == "-") return 1;
        if (aValue && !bValue) return -1;
        if (!aValue && bValue) return 1;
        return 0;
      });
    }
    variables = variables.filter(
      (variable) =>
        variable.key &&
        variable.name &&
        variable.key !== "" &&
        variable.name !== ""
    );
    setDeviceVariables(variables);

    if (device.atraso) {
      device.eventos.msg.push(
        `Atraso na comunicação: ${formataHorario(device.atraso)}`
      );
    }
  }, [device]);

  const formataHorario = (minutos: number) => {
    const horas = Math.floor(minutos / 60);
    const dias = Math.floor(horas / 24);
    const minutosRestantes = (minutos % 60).toFixed(0);
    const horasRestantes = horas % 24;

    if (dias > 0) {
      return `${dias}d ${horasRestantes}h ${minutosRestantes}m`;
    } else if (horas > 0) {
      return `${horas}h ${minutosRestantes}m`;
    } else {
      return `${minutos}m`;
    }
  };

  const getVariableValue = (key: string) => {
    if (!device.leitura?.variaveis) {
      if (typeof device.leitura[key] === "boolean") {
        return device.leitura[key] ? "Ligado" : "Desligado";
      }
      if (typeof device.leitura[key] === "number") {
        return device.leitura[key].toFixed(2);
      }
      return device.leitura ? device.leitura[key] : "N/A";
    } else {
      const variable = device.leitura.variaveis.find(
        (variable: any) => Object.keys(variable)[0] === key
      );
      return variable ? Object.values(variable)[0] : "N/A";
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-4/5 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-bold">Visualização do Dispositivo</h2>
          <button
            onClick={onCloseModal}
            className="text-red-500 hover:text-red-700 text-lg font-semibold"
          >
            ✖
          </button>
        </div>

        {device.type !== "dj" && device.type !== "sec" ? (
          <div className="grid grid-cols-4 gap-4">
            {deviceVariables?.length > 0 && device.leitura ? (
              deviceVariables.map((variable, index) => (
                <div
                  key={index}
                  className="p-2 border rounded bg-gray-100 flex flex-col"
                >
                  <span className="font-semibold text-gray-800">
                    {variable.name}
                  </span>
                  <span className="text-gray-600">
                    {getVariableValue(variable.key)}
                  </span>
                </div>
              ))
            ) : (
              <div className="col-span-2 text-center text-red-500">
                Nenhuma variável configurada para este dispositivo.
              </div>
            )}
          </div>
        ) : (
          <div className="flex items-center justify-center">
            <div className="p-4 border rounded bg-gray-100 flex flex-col items-center">
              <img
                src={require(`../assets/${
                  device.leitura?.state ? "sec-fechado.png" : "sec-aberto.png"
                }`)}
                alt="Device"
                className="w-32 h-32 object-cover mb-4"
              />
              <div className="flex space-x-4">
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-700"
                  onClick={() => CommandDj()}
                >
                  Abrir
                </button>
                <button
                  className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-700"
                  onClick={() => CommandDj()}
                >
                  Fechar
                </button>
              </div>
            </div>
          </div>
        )}
        {device.eventos.msg && device.eventos.msg?.length ? (
          <div className="mt-4">
            <h3 className="text-xl font-bold mb-2">Problemas</h3>
            <div className="grid grid-cols-3 gap-4">
              {device.eventos.msg.map((error: string, index: number) => (
                <div
                  key={index}
                  className="p-2 border rounded bg-red-200 flex flex-col"
                >
                  <span
                    className="font-semibold text-gray-800"
                    dangerouslySetInnerHTML={{ __html: error }}
                  ></span>
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default DeviceViewer;
